import LinearProgress from "@mui/material/LinearProgress";
import React from "react";

export const Indicator = ({ progress }) => {
  // Calculate color shift on the red/green scale
  const getColor = (progress) => {
    const hue = ((progress / 100) * 150).toString(10);
    return `hsl(${hue}, 100%, 50%)`;
  };

  return (
    <LinearProgress
      variant="determinate"
      value={progress}
      sx={{
        height: 4,
        width: 30,
        borderRadius: 4,
        backgroundColor: "black",
        "& .MuiLinearProgress-bar": {
          backgroundColor: getColor(progress),
        },
      }}
    />
  );
};
